import React, { useState } from 'react'
import Modal from '../Modal'
import CloseIcon from '../../assets/icon/CloseIcon'
import styles from './index.module.scss'

interface ProjectDeleteModalProps {
    isOpen: boolean
    title?: string
    text: string
    onClose: () => void
    onConfirm: () => Promise<void> | void
}

export default function ProjectDeleteModal({ isOpen, text, onClose, onConfirm , title = 'Удалить проект?',}: ProjectDeleteModalProps) {
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleConfirm = async () => {
        setIsSubmitting(true)
        try {
            await onConfirm()
        } finally {
            setIsSubmitting(false)
        }
    }

    const handleClose = () => {
        if (!isSubmitting) {
            onClose()
        }
    }

    return (
        <Modal isOpen={isOpen} onRequestClose={handleClose} width={446}>
            <div className={styles.dialog}>
                <div className={styles.dialogClose} onClick={handleClose}>
                    <CloseIcon />
                </div>
                <div className={styles.dialogContent}>
                    <h3 className={styles.dialogTitle}>{title}</h3>
                    <p className={styles.dialogText}>{text}</p>
                </div>
                <div className={styles.dialogActions}>
                    <button className={styles.secondaryButton} onClick={handleClose} disabled={isSubmitting}>
                        Отменить
                    </button>
                    <button className={styles.dangerButton} onClick={handleConfirm} disabled={isSubmitting}>
                        Удалить
                    </button>
                </div>
            </div>
        </Modal>
    )
}
